// Extended details for opportunities - Decision Workspace data
export const opportunityDetails = [
  {
    "id": "OPP-001",
    "summary": "Enterprise-wide ServiceNow ITSM modernization for HHS including CMDB, ITOM and HRSD modules. 3-year base plus options. Requires FedRAMP Moderate and hybrid onsite support.",
    "periodOfPerformance": "3 years + 2 options",
    "estimatedValue": "$18M",
    "requirements": {
      "technical": [
        "ServiceNow ITSM implementation",
        "CMDB / CSDM design",
        "ITOM discovery integration",
        "API integrations with legacy apps"
      ],
      "security": [
        "FedRAMP Moderate",
        "NIST 800-53 controls",
        "Background checks"
      ],
      "staffing": [
        "ServiceNow Architect (2)",
        "Developers (6)",
        "CMDB Lead (1)",
        "Program Manager (1)"
      ],
      "sla": [
        "99.9% uptime",
        "Incident response < 30 min",
        "Monthly KPI reporting"
      ]
    },
    "risks": [
      {"type": "Onsite Requirement", "severity": "Medium"},
      {"type": "Compressed Timeline", "severity": "Low"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 95,
      "agencyAlignment": 90,
      "deliveryFeasibility": 85,
      "complianceBurden": 70,
      "competitiveRisk": 75
    },
    "documents": [
      {"name": "RFP_Main.pdf", "size": "4.2 MB"},
      {"name": "Amendment_01.pdf", "size": "500 KB"}
    ],
    "notes": ""
  },
  {
    "id": "OPP-002",
    "summary": "Salesforce Case Management platform for NIH to streamline grant application processing and stakeholder communications. Includes Lightning migration and AppExchange integrations.",
    "periodOfPerformance": "2 years + 1 option",
    "estimatedValue": "$12M",
    "requirements": {
      "technical": [
        "Salesforce GovCloud implementation",
        "Lightning Experience migration",
        "Einstein Analytics setup",
        "Integration with NIH eRA Commons"
      ],
      "security": [
        "FedRAMP Moderate",
        "FISMA compliance",
        "MFA implementation"
      ],
      "staffing": [
        "Salesforce Architect (1)",
        "Developers (4)",
        "Admin Lead (1)",
        "Business Analyst (2)"
      ],
      "sla": [
        "99.5% uptime",
        "4-hour critical incident response",
        "Bi-weekly sprint demos"
      ]
    },
    "risks": [
      {"type": "Data Migration Complexity", "severity": "Medium"},
      {"type": "Integration Dependencies", "severity": "Medium"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 88,
      "agencyAlignment": 85,
      "deliveryFeasibility": 82,
      "complianceBurden": 75,
      "competitiveRisk": 70
    },
    "documents": [
      {"name": "RFP_Salesforce_NIH.pdf", "size": "3.8 MB"},
      {"name": "Technical_Requirements.pdf", "size": "1.2 MB"}
    ],
    "notes": ""
  },
  {
    "id": "OPP-003",
    "summary": "AWS Contact Center upgrade for CMS using Amazon Connect. Includes omnichannel support, real-time analytics, and AI-powered routing for Medicare/Medicaid inquiries.",
    "periodOfPerformance": "4 years",
    "estimatedValue": "$22M",
    "requirements": {
      "technical": [
        "Amazon Connect deployment",
        "Lex chatbot integration",
        "Real-time analytics dashboard",
        "CRM integration (ServiceNow/Salesforce)"
      ],
      "security": [
        "FedRAMP High",
        "HIPAA compliance",
        "PII/PHI handling protocols"
      ],
      "staffing": [
        "AWS Solutions Architect (2)",
        "Connect Specialists (3)",
        "ML Engineers (2)",
        "QA Lead (1)"
      ],
      "sla": [
        "99.99% availability",
        "< 2 min average wait time",
        "Real-time reporting"
      ]
    },
    "risks": [
      {"type": "HIPAA Compliance", "severity": "Medium"},
      {"type": "Scale Requirements", "severity": "Low"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 92,
      "agencyAlignment": 88,
      "deliveryFeasibility": 85,
      "complianceBurden": 65,
      "competitiveRisk": 72
    },
    "documents": [
      {"name": "CMS_ContactCenter_RFP.pdf", "size": "5.1 MB"},
      {"name": "Architecture_Guide.pdf", "size": "2.3 MB"}
    ],
    "notes": ""
  },
  {
    "id": "OPP-004",
    "summary": "Data Lake & AI Analytics platform for DHS to consolidate intelligence data and enable predictive threat detection using ML models.",
    "periodOfPerformance": "5 years",
    "estimatedValue": "$35M",
    "requirements": {
      "technical": [
        "AWS/Azure data lake architecture",
        "Snowflake data warehouse",
        "ML model development (PyTorch/TensorFlow)",
        "Real-time streaming analytics"
      ],
      "security": [
        "FedRAMP High + IL5",
        "Top Secret clearance required",
        "Air-gapped environment support"
      ],
      "staffing": [
        "Data Scientists (5)",
        "ML Engineers (4)",
        "Cloud Architects (2)",
        "Security Engineers (3)"
      ],
      "sla": [
        "24/7 operations",
        "< 5 min threat alert latency",
        "Daily model retraining"
      ]
    },
    "risks": [
      {"type": "Clearance Requirements", "severity": "High"},
      {"type": "Technical Complexity", "severity": "Medium"},
      {"type": "Partner Dependency", "severity": "Medium"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 82,
      "agencyAlignment": 78,
      "deliveryFeasibility": 68,
      "complianceBurden": 55,
      "competitiveRisk": 60
    },
    "documents": [
      {"name": "DHS_DataLake_RFP.pdf", "size": "6.2 MB"},
      {"name": "Security_Requirements.pdf", "size": "3.5 MB"}
    ],
    "notes": "Consider teaming with cleared partner for staffing"
  },
  {
    "id": "OPP-005",
    "summary": "DevSecOps toolchain implementation for VA to modernize CI/CD pipelines and integrate security scanning across all development workflows.",
    "periodOfPerformance": "3 years",
    "estimatedValue": "$15M",
    "requirements": {
      "technical": [
        "GitLab/GitHub Enterprise setup",
        "Jenkins/ArgoCD pipelines",
        "SonarQube/Fortify integration",
        "Container security (Prisma/Aqua)"
      ],
      "security": [
        "FedRAMP Moderate",
        "NIST 800-190 compliance",
        "Continuous ATO support"
      ],
      "staffing": [
        "DevSecOps Lead (1)",
        "Platform Engineers (4)",
        "Security Engineers (2)",
        "SRE (2)"
      ],
      "sla": [
        "< 30 min build times",
        "Zero critical vulnerabilities in production",
        "Weekly security scans"
      ]
    },
    "risks": [
      {"type": "Legacy System Integration", "severity": "Low"},
      {"type": "Cultural Change Management", "severity": "Low"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 78,
      "agencyAlignment": 72,
      "deliveryFeasibility": 80,
      "complianceBurden": 68,
      "competitiveRisk": 65
    },
    "documents": [
      {"name": "VA_DevSecOps_RFP.pdf", "size": "2.9 MB"}
    ],
    "notes": ""
  },
  {
    "id": "OPP-006",
    "summary": "Legacy mainframe modernization for DOL including COBOL to Java migration and cloud-native application refactoring.",
    "periodOfPerformance": "4 years + 2 options",
    "estimatedValue": "$28M",
    "requirements": {
      "technical": [
        "COBOL to Java conversion",
        "Mainframe data extraction",
        "Cloud migration (AWS/Azure)",
        "API layer development"
      ],
      "security": [
        "FedRAMP Moderate",
        "Data migration security",
        "Legacy system access controls"
      ],
      "staffing": [
        "Legacy Modernization Lead (1)",
        "COBOL Experts (3)",
        "Java Developers (6)",
        "Cloud Architects (2)"
      ],
      "sla": [
        "Zero data loss during migration",
        "< 4 hour rollback capability",
        "Parallel run support"
      ]
    },
    "risks": [
      {"type": "Legacy Complexity", "severity": "High"},
      {"type": "Knowledge Transfer", "severity": "High"},
      {"type": "Timeline Risk", "severity": "Medium"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 65,
      "agencyAlignment": 70,
      "deliveryFeasibility": 55,
      "complianceBurden": 72,
      "competitiveRisk": 58
    },
    "documents": [
      {"name": "DOL_Modernization_RFP.pdf", "size": "4.8 MB"},
      {"name": "Technical_Assessment.pdf", "size": "2.1 MB"},
      {"name": "Risk_Matrix.pdf", "size": "800 KB"}
    ],
    "notes": "High risk - recommend partnering with legacy specialist"
  },
  {
    "id": "OPP-007",
    "summary": "Helpdesk support services requiring 24x7 onsite presence. Heavy staffing and low margins.",
    "periodOfPerformance": "1 year",
    "estimatedValue": "$3M",
    "requirements": {
      "technical": [
        "Tier 1/2 helpdesk support",
        "Ticket management system",
        "Knowledge base maintenance"
      ],
      "security": [
        "Public Trust clearance",
        "Basic background checks"
      ],
      "staffing": [
        "Helpdesk Agents (25)",
        "Team Leads (3)",
        "Manager (1)"
      ],
      "sla": [
        "15 min initial response",
        "95% first call resolution",
        "24/7/365 coverage"
      ]
    },
    "risks": [
      {"type": "Low Margin", "severity": "High"},
      {"type": "High Staffing", "severity": "High"},
      {"type": "Onsite Only", "severity": "High"},
      {"type": "High Turnover Risk", "severity": "Medium"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 40,
      "agencyAlignment": 50,
      "deliveryFeasibility": 35,
      "complianceBurden": 70,
      "competitiveRisk": 85
    },
    "documents": [
      {"name": "Helpdesk_RFP.pdf", "size": "1.8 MB"}
    ],
    "notes": "Recommend No-Bid due to staffing intensity and low margins"
  },
  {
    "id": "OPP-008",
    "summary": "ServiceNow HRSD rollout for NIH to modernize HR case management, onboarding workflows, and employee self-service portal.",
    "periodOfPerformance": "2 years + 1 option",
    "estimatedValue": "$10M",
    "requirements": {
      "technical": [
        "ServiceNow HRSD implementation",
        "Employee Center portal",
        "HR integrations (PeopleSoft)",
        "Mobile app deployment"
      ],
      "security": [
        "FedRAMP Moderate",
        "PII handling compliance",
        "SSO integration"
      ],
      "staffing": [
        "HRSD Architect (1)",
        "Developers (3)",
        "HR SME (2)",
        "Change Management Lead (1)"
      ],
      "sla": [
        "99.5% uptime",
        "< 24 hour case resolution",
        "Monthly satisfaction surveys"
      ]
    },
    "risks": [
      {"type": "Change Management", "severity": "Medium"},
      {"type": "Integration Complexity", "severity": "Low"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 88,
      "agencyAlignment": 82,
      "deliveryFeasibility": 85,
      "complianceBurden": 75,
      "competitiveRisk": 68
    },
    "documents": [
      {"name": "NIH_HRSD_RFP.pdf", "size": "3.2 MB"}
    ],
    "notes": ""
  },
  {
    "id": "OPP-009",
    "summary": "Salesforce DevOps implementation using Copado for CMS to establish CI/CD pipelines and automated testing for Salesforce releases.",
    "periodOfPerformance": "2 years",
    "estimatedValue": "$8M",
    "requirements": {
      "technical": [
        "Copado implementation",
        "Salesforce DX setup",
        "Automated testing framework",
        "Release management process"
      ],
      "security": [
        "FedRAMP Moderate",
        "Code scanning integration",
        "Audit trail requirements"
      ],
      "staffing": [
        "Copado Specialist (1)",
        "Salesforce DevOps Engineers (3)",
        "QA Automation Lead (1)"
      ],
      "sla": [
        "< 2 hour deployment windows",
        "Zero production rollbacks",
        "Weekly releases supported"
      ]
    },
    "risks": [
      {"type": "Tool Learning Curve", "severity": "Medium"},
      {"type": "Process Change", "severity": "Medium"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 80,
      "agencyAlignment": 78,
      "deliveryFeasibility": 75,
      "complianceBurden": 72,
      "competitiveRisk": 70
    },
    "documents": [
      {"name": "CMS_Copado_RFP.pdf", "size": "2.5 MB"}
    ],
    "notes": ""
  },
  {
    "id": "OPP-010",
    "summary": "AI-powered fraud analytics platform for HHS leveraging cloud data lake and machine learning models for Medicare/Medicaid fraud detection.",
    "periodOfPerformance": "5 years",
    "estimatedValue": "$25M",
    "requirements": {
      "technical": [
        "AWS data lake architecture",
        "Snowflake data warehouse",
        "ML pipelines (SageMaker)",
        "Fraud detection models",
        "Real-time scoring engine"
      ],
      "security": [
        "FedRAMP High",
        "PHI/PII compliance",
        "HIPAA requirements",
        "Encryption at rest/transit"
      ],
      "staffing": [
        "Data Scientists (4)",
        "ML Engineers (3)",
        "Cloud Engineers (3)",
        "Security Lead (1)",
        "Program Manager (1)"
      ],
      "sla": [
        "Daily model refresh",
        "99.95% availability",
        "< 100ms scoring latency",
        "Weekly model performance reports"
      ]
    },
    "risks": [
      {"type": "High Compliance Burden", "severity": "High"},
      {"type": "Incumbent Present", "severity": "Medium"},
      {"type": "Data Quality Dependencies", "severity": "Medium"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 93,
      "agencyAlignment": 92,
      "deliveryFeasibility": 80,
      "complianceBurden": 60,
      "competitiveRisk": 65
    },
    "documents": [
      {"name": "RFP_AI_Fraud.pdf", "size": "3.1 MB"},
      {"name": "Data_Requirements.pdf", "size": "1.5 MB"},
      {"name": "Compliance_Checklist.pdf", "size": "900 KB"}
    ],
    "notes": ""
  },
  {
    "id": "OPP-011",
    "summary": "Zero Trust security architecture implementation for DHS to modernize network security posture across all agency systems.",
    "periodOfPerformance": "3 years",
    "estimatedValue": "$20M",
    "requirements": {
      "technical": [
        "Zero Trust architecture design",
        "Identity-based access controls",
        "Micro-segmentation",
        "SASE implementation"
      ],
      "security": [
        "FedRAMP High",
        "CISA Zero Trust Maturity Model",
        "OMB M-22-09 compliance"
      ],
      "staffing": [
        "Zero Trust Architect (2)",
        "Security Engineers (5)",
        "Network Engineers (3)",
        "IAM Specialists (2)"
      ],
      "sla": [
        "Continuous monitoring",
        "< 15 min incident detection",
        "Weekly vulnerability scans"
      ]
    },
    "risks": [
      {"type": "Scope Complexity", "severity": "High"},
      {"type": "Organizational Change", "severity": "High"},
      {"type": "Budget Constraints", "severity": "Medium"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 55,
      "agencyAlignment": 60,
      "deliveryFeasibility": 45,
      "complianceBurden": 50,
      "competitiveRisk": 72
    },
    "documents": [
      {"name": "DHS_ZeroTrust_RFP.pdf", "size": "4.5 MB"}
    ],
    "notes": "Complex scope - recommend No-Bid unless partnered"
  },
  {
    "id": "OPP-012",
    "summary": "Cloud migration support for VA to move legacy applications to AWS GovCloud with modernization where applicable.",
    "periodOfPerformance": "3 years + 1 option",
    "estimatedValue": "$16M",
    "requirements": {
      "technical": [
        "AWS GovCloud migration",
        "Application assessment",
        "Lift-and-shift execution",
        "Modernization roadmap"
      ],
      "security": [
        "FedRAMP High",
        "VA security requirements",
        "Continuous ATO support"
      ],
      "staffing": [
        "Cloud Migration Lead (1)",
        "AWS Architects (2)",
        "DevOps Engineers (4)",
        "App SMEs (3)"
      ],
      "sla": [
        "Zero unplanned downtime",
        "< 48 hour migration windows",
        "100% data integrity"
      ]
    },
    "risks": [
      {"type": "Application Complexity", "severity": "Medium"},
      {"type": "Timeline Pressure", "severity": "Medium"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 72,
      "agencyAlignment": 68,
      "deliveryFeasibility": 70,
      "complianceBurden": 65,
      "competitiveRisk": 62
    },
    "documents": [
      {"name": "VA_CloudMigration_RFP.pdf", "size": "3.8 MB"}
    ],
    "notes": ""
  },
  {
    "id": "OPP-013",
    "summary": "CMDB implementation using ServiceNow for HHS to establish authoritative IT asset repository with automated discovery.",
    "periodOfPerformance": "2 years",
    "estimatedValue": "$9M",
    "requirements": {
      "technical": [
        "ServiceNow CMDB/CSDM",
        "Discovery implementation",
        "Service mapping",
        "Integration hub setup"
      ],
      "security": [
        "FedRAMP Moderate",
        "Asset classification",
        "Access controls"
      ],
      "staffing": [
        "CMDB Architect (1)",
        "Discovery Specialists (2)",
        "Developers (2)",
        "Data Quality Lead (1)"
      ],
      "sla": [
        "95% discovery accuracy",
        "Weekly CI reconciliation",
        "< 24 hour CI updates"
      ]
    },
    "risks": [
      {"type": "Data Quality", "severity": "Medium"},
      {"type": "Stakeholder Adoption", "severity": "Low"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 90,
      "agencyAlignment": 85,
      "deliveryFeasibility": 88,
      "complianceBurden": 78,
      "competitiveRisk": 70
    },
    "documents": [
      {"name": "HHS_CMDB_RFP.pdf", "size": "2.8 MB"}
    ],
    "notes": ""
  },
  {
    "id": "OPP-014",
    "summary": "Reporting and BI modernization for DOL using modern analytics tools to replace legacy reporting systems.",
    "periodOfPerformance": "2 years + 1 option",
    "estimatedValue": "$11M",
    "requirements": {
      "technical": [
        "Power BI / Tableau deployment",
        "Data warehouse modernization",
        "ETL pipeline development",
        "Self-service analytics"
      ],
      "security": [
        "FedRAMP Moderate",
        "Data governance framework",
        "Row-level security"
      ],
      "staffing": [
        "BI Architect (1)",
        "Data Engineers (3)",
        "BI Developers (2)",
        "Training Lead (1)"
      ],
      "sla": [
        "Daily data refresh",
        "99.5% report availability",
        "< 10 second report load"
      ]
    },
    "risks": [
      {"type": "Data Migration", "severity": "Medium"},
      {"type": "User Adoption", "severity": "Medium"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 75,
      "agencyAlignment": 72,
      "deliveryFeasibility": 78,
      "complianceBurden": 70,
      "competitiveRisk": 65
    },
    "documents": [
      {"name": "DOL_BI_RFP.pdf", "size": "2.4 MB"}
    ],
    "notes": ""
  },
  {
    "id": "OPP-015",
    "summary": "Network Operations Center support services for VA requiring 24/7 monitoring and incident response.",
    "periodOfPerformance": "1 year + 2 options",
    "estimatedValue": "$5M",
    "requirements": {
      "technical": [
        "NOC operations",
        "Network monitoring tools",
        "Incident management",
        "Performance reporting"
      ],
      "security": [
        "Public Trust + Secret",
        "VA network access",
        "Background investigations"
      ],
      "staffing": [
        "NOC Analysts (15)",
        "Shift Supervisors (4)",
        "NOC Manager (1)"
      ],
      "sla": [
        "24/7/365 coverage",
        "< 5 min alert response",
        "99% ticket accuracy"
      ]
    },
    "risks": [
      {"type": "Staffing Intensity", "severity": "High"},
      {"type": "Clearance Requirements", "severity": "High"},
      {"type": "Low Margin", "severity": "High"}
    ],
    "scoreBreakdown": {
      "technologyAlignment": 45,
      "agencyAlignment": 52,
      "deliveryFeasibility": 40,
      "complianceBurden": 55,
      "competitiveRisk": 80
    },
    "documents": [
      {"name": "VA_NOC_RFP.pdf", "size": "2.1 MB"}
    ],
    "notes": "Recommend No-Bid - not aligned with core capabilities"
  }
];

// Helper to get details by ID
export const getOpportunityDetails = (id) => {
  return opportunityDetails.find(opp => opp.id === id);
};
